import { render, staticRenderFns } from "./DestinationReport.vue?vue&type=template&id=206d57c0&scoped=true&"
import script from "./DestinationReport.vue?vue&type=script&lang=js&"
export * from "./DestinationReport.vue?vue&type=script&lang=js&"
import style0 from "./DestinationReport.vue?vue&type=style&index=0&id=206d57c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206d57c0",
  null
  
)

component.options.__file = "DestinationReport.vue"
export default component.exports